import { jdiColorFetch } from '@/apis/colorFetchV2';
import type { Response } from '@/apis/common.types';
import { FloorDetailData, GetFloorRequest } from './api.interface';

export const getFloorDetailData = (
  requestData: GetFloorRequest,
): Promise<Response<FloorDetailData>> => {
  return jdiColorFetch(`trade_item_getFloor`, {
    method: 'get',
    bodyQuery: {
      ...requestData,
      verticalTag: 'cn_ybxt_b2c',
    },
  });
};
